<template>
  <a-modal
      v-model:open="modalContent.visible"
      :title="modalContent.title"
      centered
      width="auto"
      style="max-width: 85%; max-height: 80%;"
  >

    <a-flex justify="center" align="center" class="full">
      <div style="overflow-y: auto; overflow-x: hidden;">
        <dlc-card-grid :data="modalContent.dlcs"
                       :grid="{gutter: 16, xs: 1, lg: 2}"
        >
          <template v-slot:card="items">
            <dlc-card :item="items.item" @showModal="showModal"/>
          </template>
        </dlc-card-grid>
      </div>
    </a-flex>
    <template #footer>
      <a-button type="primary" @click="modalContent.visible = false;">Close</a-button>
    </template>
  </a-modal>

  <div class="background">
    <img class="background-img" src="@/assets/bg.jpg" alt="background">
  </div>

  <a-flex justify="center" align="center" vertical class="full">
    <div style="overflow-y: auto; overflow-x: hidden;">
      <a-typography-title class="title" align="center">
        MFA User Guide
      </a-typography-title>
      <dlc-card-grid :data="dlcs"
                     :grid="{gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 4}"
                     @show-modal="showModal">
        <template v-slot:card="items">
          <dlc-card :item="items.item" @showModal="showModal"/>
        </template>
      </dlc-card-grid>
    </div>
  </a-flex>
</template>

<script>
import DlcCardGrid from "@/components/CardGrid.vue";
import {defineComponent} from "vue";
import DlcCard from "@/components/DlcCard.vue";

export default defineComponent({
  components: {DlcCard, DlcCardGrid},
  data: function () {
    return {
      dlcs: [],
      modalContent: {
        title: "Nothing",
        visible: false,
        dlcs: []
      },
    }
  },
  created: function () {
    this.updateIndex();
  },
  methods: {
    updateIndex() {
      fetch(process.env.BASE_URL + "index.json").then(res => {
        res.json().then(index => {
          this.dlcs = index
              .filter(el => !el.hide)
              .sort((a, b) => a.id - b.id);
        });
      });
    },
    showModal(content) {
      this.modalContent = content;
      this.modalContent.visible = true;
    }
  }
});

</script>

<style scoped>
.background {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
}

.background-img {
  width: 100%;
  height: 100%;
}

.full {
  height: 100%;
  width: 100%;
}

.title {
  margin-top: 50px;
  margin-bottom: 50px;
  color: whitesmoke;
}
</style>